export default function isMobile() {
  // eslint-disable-next-line no-magic-numbers
  return window.innerWidth < 768;
}
